// src/panel/AdminPanel.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import api from "../../../api/api";
import '../styles/AdminPanel.css';

// Icons
import dashboardIcon from '../icons/dashboard.png';
import logoutIcon from '../icons/logout.png';
import noticeIcon from '../icons/notice.png';
import notificationIcon from '../icons/notification.png';
import feesIcon from '../icons/fees.png';
import storeIcon from '../icons/store.png';
import transportIcon from '../icons/transport.png';
import hallticketIcon from '../icons/hallticket.png';
import userIcon from '../icons/user.svg';
import teacherIcon from '../icons/teacher.svg';
import bookIcon from '../icons/book.svg';
import timetableIcon from '../icons/timetable.png';
import studentIcon from '../icons/student.svg';

const iconMap = {
  'Admin Dashboard': dashboardIcon,
  'Manage User': userIcon,
  'Assign Teacher': teacherIcon,
  'Assign Students': studentIcon,
  'Class Timetable': timetableIcon,
  'Add Booklist': bookIcon,
  'Compose Notice': noticeIcon,
  'Compose Notification': notificationIcon,
  'Fee Structure': feesIcon,
  'Store Management': storeIcon,
  'Manage Transport': transportIcon,
  'Manage Hall Ticket': hallticketIcon,
};

const AdminPanel = ({ onToggle, hideToggle = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activePath, setActivePath] = useState(location.pathname);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [modules, setModules] = useState([]);

  const adminId = localStorage.getItem('userId');
  const token = localStorage.getItem('token');

  // Fetch enabled admin modules
  useEffect(() => {
    const fetchModules = async () => {
      try {
        const schoolId = localStorage.getItem('schoolId');
const res = await api.get(`/api/modules/${schoolId}`, {
  headers: { Authorization: `Bearer ${token}` },
});


       const enabledModules = res.data.filter(
  (m) => m.role === 'admin' && m.enabled
);

        setModules(enabledModules);
      } catch (err) {
        console.error('Error fetching modules:', err);
      }
    };

    fetchModules();
  }, [token]);

  const handleNavigate = (path) => {
    setActivePath(path);
    navigate(path);

    if (window.innerWidth <= 768) {
      document.querySelector('.aq-panel').classList.remove('expanded');
    }
  };

  const handleLogout = () => {
    const role = localStorage.getItem('role') || 'admin';
    localStorage.clear();
    navigate(`/portal/${role}`);
  };

  const toggleSidebar = () => {
    const panel = document.querySelector('.aq-panel');
    if (window.innerWidth <= 768) {
      panel.classList.toggle('expanded');
    } else {
      setIsCollapsed(!isCollapsed);
      if (onToggle) onToggle(!isCollapsed);
    }
  };

  return (
    <div className="aq-panel-wrapper">
      {!hideToggle && (
        <div
          className={`toggle-button-outside ${isCollapsed ? 'collapsed' : ''}`}
          onClick={toggleSidebar}
        >
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      )}

      <div className={`aq-panel ${isCollapsed ? 'collapsed' : ''}`}>
        <div className="admin-panel-header">
  <div className="panel-header-overlay">
    {!isCollapsed && <span className="header-title">Admin Panel</span>}
  </div>
</div>


        <div className="aq-list">
          {modules.map((mod, index) => {
  const path = mod.path.replace(':id', adminId);
  return (
    <button
      key={`${mod.id || mod.name || 'mod'}-${index}`}
      className={activePath === path ? 'active' : ''}
      onClick={() => handleNavigate(path)}
    >

                <img
                  src={iconMap[mod.name] || dashboardIcon}
                  alt={mod.name}
                  className={`icon ${activePath === path ? 'active-icon' : ''}`}
                />
                {!isCollapsed && (
                  <span className="button-content">
                    {mod.name} <span className="arrow">&gt;</span>
                  </span>
                )}
              </button>
            );
          })}

          {/* Logout button */}
          <button onClick={handleLogout}>
            <img src={logoutIcon} alt="Logout" className="icon" />
            {!isCollapsed && (
              <span className="button-content">
                Logout <span className="arrow">&gt;</span>
              </span>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;
